// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//**样式**//
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import Login from '@/components/style/base.css'
import Iconfont from '@/iconfont/iconfont.css'
import { HTTP } from './util/axios';
/*import Base from 'base'*/
import 'babel-polyfill'
import '@/components/style/pubilc.css'

import Common from './components/js/common.js';
import { initSign } from '@didi/wsgsig';

initSign({
  appVer: 'v1.0',
  os: '4',
  bizId: '9d9561b9724fcc2dc28406179c11c688'
});

Vue.prototype.$common = Common;

Vue.prototype.$http = HTTP;
Vue.config.productionTip = false;

// 格式化时间
Vue.prototype.formatHtml= function (str) {
  let arr = str.split(',');
  let html = '';
  for(let i=0; i<arr.length; i++){
    if(i !== 0 ){
      html+=`<div style="margin-top:-5px;">${arr[i]}</div>`;
    }else{
      html+=`<div>${arr[i]}</div>`;
    }
  }
  return html;
};
import VueDOMPurifyHTML from 'vue-dompurify-html';
Vue.use(VueDOMPurifyHTML);

//**注册ui模块**//
//配置全局ivew的message
iView.Message.config({
  duration: 3,
})
//**注册ui模块**//
Vue.use(iView);

//引入置灰插件
import Gray from './components/js/gray.js';

Vue.prototype.$gray = new Gray();

//引入moment
import Moment from 'moment';
Vue.prototype.$moment = Moment;

//声明一个全局的过滤器
Vue.filter('convertTime', function (value) { //{{value|convertTime}}
  return Moment(value).format('HH:mm');
})
Vue.filter('convertTimeMin', function (value) { //{{value|convertTime}}
  return Moment(value).format('YYYY-MM-DD HH:mm');
})
//引入feedBack
// import { feedBack } from "./config/feedBack";
import ImageViewer from '@/util/vue-imageViewer-master' // 图片查看
Vue.use(ImageViewer);

//数据埋点
var dataCtrl = function (name, action) {
  //队列中放置sendEventlogMessageToKafka命令，发送event事件
  console.log(name,action)
  window.taotieCommandQueue = window.taotieCommandQueue || [];
  let parameterObject = {};
  parameterObject.category = name; //事件种类或者叫事件类别
  parameterObject.action = action; //事件操作
  taotieCommandQueue.push({ command: 'sendEventlogMessageToKafka', parameter: parameterObject });
}

Vue.prototype.$dataCtrl = dataCtrl;
window.taotieCommandQueue = window.taotieCommandQueue || [];
window.taotieCommandQueue.push({ command: 'setCookieUserName', parameter: 'count_name_display' });

import { api } from '@/config'
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
  window.taotieCommandQueue.push({ command: 'setCookieSystemNameForTaotie', parameter: 'Shiyu-Pc' });
} else {
  window.taotieCommandQueue.push({ command: 'setCookieSystemNameForTaotie', parameter: 'Shiyu-PcTest' });
}

import omegaTracker from '@didi/omega-tracker-lite';
Vue.prototype.Omega = omegaTracker.getTracker({
  appKey: 'omega4b39b5f495', // 应用唯一标识
  // 用户id
  userId: '123',
  autoClick: false, // 全局点击事件监控，如不需要 建议关闭
  // 城市
  cityId: 1
});

window.vue = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: {
    eventComp: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js